import React from 'react';
import { ApolloClient, createNetworkInterface, ApolloProvider } from 'react-apollo';
import { connect } from 'react-redux';

import CoreLayout from './layouts/PageLayout/PageLayout';
import ResetPasswordRoute from './routes/ChangePassword';
import ChangePasswordRoute from './routes/ChangePassword/change';
import ForgotPasswordRoute from './routes/ForgotPassword';

const mapStateToProps = (state) => ({
  authedUserID: state.auth.sub || null,
  authedUser: state.auth || null,
});

export const createRoutes = (store) => {
  return ({
    path: 'user',
    component: connect(mapStateToProps)(props => {
      let GraphQLURI = __GraphQLPublic || publicEndpoint; // eslint-disable-line no-undef
      if (props.authedUserID !== null) {
        GraphQLURI = __GraphQLProtected || protectedEndpoint; // eslint-disable-line no-undef
      }
      
      let ApolloNetworkInstance = createNetworkInterface({
        uri: GraphQLURI,
        opts: {
          headers: {
            'Authorization': 'Bearer ' + (props.authedUser.rawToken || 'unauthed'),
          }
        }
      });

      let ApolloClientInstance = new ApolloClient({
        networkInterface: ApolloNetworkInstance,
      });

      return (
        <ApolloProvider client={ApolloClientInstance}>
          <CoreLayout store={store} {...props} />
        </ApolloProvider>
      );
    }),
    childRoutes: [
      ChangePasswordRoute(store),
      ResetPasswordRoute(store),
      ForgotPasswordRoute(store),
    ]
  });
};

export default createRoutes;



// WEBPACK FOOTER //
// ./src/routes/user/index.js